import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import PensionPlansSection from "./components/PensionPlansSection";
import CalculatorSection from "./components/CalculatorSection";
import BenefitsSection from "./components/BenefitsSection";
import Footer from "./components/Footer";
import LiveNotification from "./components/LiveNotification";

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <PensionPlansSection />
        <CalculatorSection />
        <BenefitsSection />
      </main>
      <Footer />
      <LiveNotification />
    </div>
  );
}
